import { defineStore } from 'pinia'
import type { PlatformStaff } from '@/types/platformStaff'
import { platformAuthService } from '@/services/admin/platformAuth.service'
import { setAuthToken } from '@/services/http/httpClient'

const STORAGE_KEY = 'ereach.platformAuth.staff'

function readPersistedStaff(): PlatformStaff | null {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as PlatformStaff
  } catch {
    return null
  }
}

export const usePlatformAuthStore = defineStore('platformAuth', {
  state: () => ({
    staff: readPersistedStaff(),
    status: 'idle' as 'idle' | 'loading' | 'error',
  }),
  getters: {
    isAuthenticated: (state) => state.staff !== null,
  },
  actions: {
    async login(email: string, _password: string) {
      this.status = 'loading'
      try {
        this.staff = await platformAuthService.login(email, _password)
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.staff))
        this.status = 'idle'
      } catch (error) {
        this.status = 'error'
        throw error
      }
    },
    async logout() {
      await platformAuthService.logout()
      this.forgetSession()
    },

    /** Drops the local session without calling the API — used when the API already rejected us. */
    forgetSession() {
      this.staff = null
      localStorage.removeItem(STORAGE_KEY)
      setAuthToken(null, true, 'platform')
    },
  },
})
